/* filter data for shipment */


export const namespaced = true

export const state = {
    agent_type:"All",
}

export const mutations = {
    SET_AGNET_TYPE_FILTER(state, {
        agent_type,
    }) {
        state.agent_type = agent_type
    },
}
export const actions = {
    setAgentTypeFilter({
        commit
    }, items) {
        commit('SET_AGNET_TYPE_FILTER', items)
    },
}
export const getters = {
    getAgentTypeFilter: state => {
        return state;
    },
}